import React from "react";
import { ConfirmProvider } from "./confirmContext";
import { LoadingProvider } from "./loadingContext";
import { NotificationProvider } from "./notificationContext/notificationContext";

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ConfirmProvider>
      <LoadingProvider>
        <NotificationProvider>
        {children}
        </NotificationProvider>
      </LoadingProvider>
    </ConfirmProvider>
  );
};
